'use client'

import { Breakpoints } from '@fukku/styles/breakpoints'
import type { PointOfInterestImage } from 'landings/Home/Home.type'
import { pointOfInterestImageLoaderFactory } from 'landings/utils/pointOfInterestImageLoaderFactory'

import { getPointOfInterest } from '../../../utils/getPointOfInterest/getPointOfInterest'
import { BannerImage } from '../../Shared/BannerImage/BannerImage'

type HeroBannerImageProps = {
	readonly image: PointOfInterestImage
	readonly isAlwaysPortrait?: boolean
	readonly priority?: boolean
}

const ASPECT_RATIO_WIDTH = 16
const ASPECT_RATIO_HEIGHT = 6
const ASPECT_RATIO_LARGE = ASPECT_RATIO_WIDTH / ASPECT_RATIO_HEIGHT
const ASPECT_RATIO_SMALL = 1

export function HeroBannerSecondaryLinesImage({
	image,
	priority = false,
}: HeroBannerImageProps) {
	const heroBannerImageLoader = pointOfInterestImageLoaderFactory(
		getPointOfInterest({ image }),
		(width) => {
			if (width <= Breakpoints.large) {
				return width / ASPECT_RATIO_SMALL
			}
			return width / ASPECT_RATIO_LARGE
		}
	)

	return (
		<BannerImage
			image={image}
			imageLoader={heroBannerImageLoader}
			priority={priority}
		/>
	)
}
